/**
 * Created by valentin on 19/07/2017.
 */
import React from 'react'
import PropTypes from 'prop-types'
import { getTooth } from '../../../../resources/utilities'
import {polyglot} from '../../../../index'
import Loading from '../../../common/Loading/Loading'
import FormRenderer from '../../../common/FormRenderer/FormRenderer'

export default class ToothStateForm extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      toothState: props.state
    }
    this.handleChange = this.handleChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  componentDidMount () {
    getTooth(this.props.id, this.state.toothState)
      .then(image => {
        this.setState({image: image})
      })
  }

  componentWillUpdate (nextProps, nextState) {
    if (this.state.toothState !== nextState.toothState) {
      getTooth(this.props.id, nextState.toothState).then(function (image) {
        this.setState({
          image: image
        })
      }.bind(this))
    }
  }

  handleSubmit (element) {
    this.props.submitChange(this.props.id, element.toothState)
  }

  renderContent () {
    if (this.props.config) {
      return <FormRenderer
        dataKey={this.props.config.key}
        handleChange={this.handleChange}
        savedData={{toothState: this.state.toothState}}
        saveData={this.handleSubmit}
        title={this.props.config.title}
        extraFieldContent={this.props.config.extraFieldContent}
        fields={this.props.config.fields}
        buttonStyle={'btn btn-block btn-primary'}
        extraFieldEnabled={this.props.config.isExtraFieldEnabled} />
    } else {
      return <Loading />
    }
  }

  handleChange (data) {
    this.setState({
      toothState: data.toothState
    })
  }
  render () {
    return <div className='row'>
      <div className='col-sm-3 tooth-view'>
        {this.state.image ? <img src={this.state.image.src} alt={polyglot.t('commonFields.image')} /> : null}
      </div>
      <div className='col-sm-9'>
        <div>
          {this.renderContent()}
        </div>
      </div>
    </div>
  }
}

ToothStateForm.propTypes = {
  config: PropTypes.object.isRequired,
  id: PropTypes.number,
  state: PropTypes.string,
  submitChange: PropTypes.func.isRequired
}



// WEBPACK FOOTER //
// ./src/components/general/TeethView/ToothStateForm/ToothStateForm.js